import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import kakaoImg from '../../../asset/img/linktodata_m_kakao_img.jpg';
import tossImg from '../../../asset/img/linktodata_m_toss_img.jpg';

import Button from '../../../components/common/Button';

// import SubTitleSection from '../../../components/SubTitleSection';
import Typography from '../../../components/common/Typography';
import { getAlertMessageFunction, getCurrentYear } from '../../../common/Util';
import { sendCertConfirm } from '../eDocumentsSlice';
import { useTranslation } from 'react-i18next';
import { kakaoTossSelectItem02 } from '../../../common/data';
// import Button from '../../../components/common/Button';

const Step3 = ({ stepHandler, selectedItem }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('eDocuments');
  const { myInfo } = useSelector(state => state.myInfo);
  const { uuid } = useSelector(state => state.eDocuments);
  const itemList = kakaoTossSelectItem02(t);
  const [item, setItem] = useState({
    title: '카카오톡',
    img: kakaoImg,
    description: (
      <>
        1. 카카오 인증서 이용에 문제가 있는 경우, [고객센터 도움말] 에서 해결 방법을 찾아보세요.
        <br />
        2. 문제가 지속되면 [고객센터 문의하기] 또는 [상담톡 채널] 채팅하기를 통해 문의해 주세요.
      </>
    ),
  });
  // const { t } = useTranslation('eDocuments');
  useEffect(() => {
    setItem(itemList[selectedItem]);
  }, [selectedItem]);

  const onSubmit = () => {
    const formData = {
      uuid: uuid,
      htmComCd: myInfo?.htmComCd?.trim() || 'jan',
      htmPerSabun: myInfo?.htmPerSabun?.trim() || 'rnd23066',
      htmYy: getCurrentYear(),
      // secretKey: 'Lwvw87zs3Nh1LiFDavMd',
    };

    onCertConfirm(formData);
  };

  const onCertConfirm = async formData => {
    const alertMessage = getAlertMessageFunction();
    const response = await dispatch(sendCertConfirm(formData)).unwrap();
    const { resultCode, resultMsg } = response;
    if (resultCode === '1') {
      stepHandler(5);
    } else {
      alertMessage(resultMsg);
    }
  };

  return (
    <div>
      {/* <SubTitleSection title={t('linkToData.step1.title')} img={titleImg} /> */}
      <div>
        <Typography className="body2Medium" style={{ textAlign: 'center' }}>
          {item.title} {t('linkToData.step3.title')}
          <br />
          {t('linkToData.step3.description')}
          <br />
          {item.title} {t('linkToData.step3.description2')}
        </Typography>

        <div
          style={{
            padding: '40px 16px 0px 16px',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            alignItems: 'center',
          }}>
          <img src={item.img} style={{ width: '70px' }} />
          <Typography className="captionMedium">{t('linkToData.step3.description3')}</Typography>
        </div>
      </div>
      <div
        style={{
          position: 'fixed',
          bottom: 0,
          width: '100%',
          left: 0,
          padding: '20px 16px 30px',
          display: 'flex',
          gap: '40px',
          flexDirection: 'column',
        }}>
        <div style={{ padding: '16px', borderRadius: '8px', background: '#f5f5f5' }}>
          <Typography className="captionMedium" style={{ whiteSpace: 'pre-wrap' }}>
            {/* {t('linkToData.step3.description4')}
            <br /> */}
            {item.description}
          </Typography>
        </div>
        <div>
          <Button value={t('linkToData.step3.button')} fullWidth onClick={onSubmit} />
        </div>
      </div>
    </div>
  );
};

export default Step3;
